import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import "./ModelListingScreen.css";
function FaqScreen() {
  return <Row id="homeScreenModel"></Row>;
}

export default FaqScreen;
